module.exports = __webpack_public_path__ + "img/article-gb-dwrg-6.4bee09c1.jpg";